import React from 'react';
import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField, LookupField } from 'react/components/fields';

const TaskResolutionCrud = (props) => (
  <BaseCrud updateMethod="PATCH" tabName="TaskResolution.title" {...props}>
    <FormSection title="TaskResolution.section.general.title">
      <FormSectionColumn>
      <LookupField
          label="TaskResolution.field.organization"
          name="organization"
          lookupEntity="Organization"
          lookupEntityColumn="description"
          required
        />
        <TextField
          label="TaskResolution.field.description"
          name="description"
          required
        />
      </FormSectionColumn>
    </FormSection>
  </BaseCrud>
);

export default TaskResolutionCrud;
